module.exports = __webpack_public_path__ + "img/31800.ac837b4b.jpg";